import React from "react";
import Stack from "components/common/Stack";
import Text from "components/common/Text";

/**
 * Figma 7991:127231 — "Section Header Row" (bold title + blue link).
 */
const ProfileSectionHeaderRow = ({ title, linkLabel, onLinkClick }) => (
  <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
    <Text sx={{ fontWeight: 700, fontSize: { xs: "18px", md: "20px" }, color: "#111827" }}>
      {title}
    </Text>
    {linkLabel ? (
      <Text
        onClick={onLinkClick}
        sx={{
          fontWeight: 600,
          fontSize: { xs: "13px", md: "14px" },
          color: "#3B82F6",
          textDecoration: "underline",
          cursor: "pointer",
          whiteSpace: "nowrap",
        }}
      >
        {linkLabel}
      </Text>
    ) : null}
  </Stack>
);

export default ProfileSectionHeaderRow;
